/* eslint-disable no-unused-vars */

// Type date filter
export enum DateFilterCategory {
  ROLLING = "ROLLING",
  FIXED = "FIXED"
}